module.exports = __webpack_public_path__ + "media/images/checkout/challenger/plus_teal-a8833e3822ab6234fc4ae944a2dca787.svg";